// extracted by mini-css-extract-plugin
module.exports = {"WaitClaimLoading":"WaitLoading_WaitClaimLoading__OXmvl","loadingIcon":"WaitLoading_loadingIcon__7av__","loadingImg":"WaitLoading_loadingImg__OnZuH"};